// English participant UI uses en-US. Exact product-copy overrides leave source
// quotations, official titles, stored answers, and Spanish translations intact.
const copy = new Map<string, string>([
  ["Have you ever been formally charged with an offence?", "Have you ever been formally charged with an offense?"],
  ["Use an address you check while you are travelling.", "Use an address you check while you are traveling."],
  ["Including arrests that led to no charge, and matters you believe were expunged or cancelled.", "Including arrests that led to no charge, and matters you believe were expunged or canceled."],
]);
export function usEnglish(text: string): string {
  return copy.get(text) ?? text;
}
